/* pb-how-to-use-slider.js */
document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.pb-slider');

  sliders.forEach(slider => {
    const track = slider.querySelector('.pb-slider__track');
    const slides = slider.querySelectorAll('.pb-slider__slide');
    const prevBtn = slider.querySelector('.pb-slider__nav--prev');
    const nextBtn = slider.querySelector('.pb-slider__nav--next');
    const dots = slider.querySelectorAll('.pb-slider__dot');
    const progressBar = slider.querySelector('.pb-slider__progress-bar');

    if (!slides.length) return;

    let currentIndex = 0;
    let isAnimating = false;
    let autoplayTimer = null;
    let startTime = null;
    let remainingTime = 0;
    let isPaused = false;

    const autoplay = slider.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(slider.dataset.speed) || 5000;

    // Detect touch-only devices so we skip mouse hover pause on mobile.
    // On Android, mouseenter fires on tap before click, which sets isPaused=true
    // and permanently breaks autoplay after the first manual navigation.
    const isTouchDevice = window.matchMedia('(hover: none) and (pointer: coarse)').matches;

    // Touch variables
    let touchStartX = 0;
    let touchEndX = 0;

    /* ── Core slide function ─────────────────────────────── */
    const goToSlide = (index) => {
      if (isAnimating || index === currentIndex) return;
      isAnimating = true;

      // Infinite loop wrap
      if (index < 0) {
        index = slides.length - 1;
      } else if (index >= slides.length) {
        index = 0;
      }

      // Remove active state from current slide
      slides[currentIndex].classList.remove('is-active');
      if (dots.length) {
        dots[currentIndex].classList.remove('is-active');
        dots[currentIndex].setAttribute('aria-selected', 'false');
      }

      // Apply active state to new slide
      currentIndex = index;
      slides[currentIndex].classList.add('is-active');
      if (dots.length) {
        dots[currentIndex].classList.add('is-active');
        dots[currentIndex].setAttribute('aria-selected', 'true');
      }

      // Release animation lock after transition completes
      setTimeout(() => { isAnimating = false; }, 600);

      // Always reset autoplay when manually navigating —
      // ensures user gets the full duration to read the new slide.
      if (autoplay) resetAutoplay();
    };

    const nextSlide = () => goToSlide(currentIndex + 1);
    const prevSlide = () => goToSlide(currentIndex - 1);

    /* ── Navigation event listeners (clean, single binding) ─ */
    if (prevBtn) prevBtn.addEventListener('click', prevSlide);
    if (nextBtn) nextBtn.addEventListener('click', nextSlide);

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => goToSlide(index));
    });

    /* ── Keyboard navigation ─────────────────────────────── */
    slider.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft')  prevSlide();
      if (e.key === 'ArrowRight') nextSlide();
    });

    /* ── Touch / swipe support ───────────────────────────── */
    track.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
      // Pause during the swipe gesture itself
      pauseAutoplay();
    }, { passive: true });

    track.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;
      const swipeThreshold = 50;

      if (Math.abs(diff) >= swipeThreshold) {
        // goToSlide → resetAutoplay handles the restart
        if (diff > 0) nextSlide();
        else           prevSlide();
      } else {
        // No swipe — resume from where we paused
        if (autoplay && !isPaused) resumeAutoplay();
      }
    }, { passive: true });

    /* ── Autoplay core ───────────────────────────────────── */
    const startAutoplay = () => {
      if (!autoplay) return;
      startTime = Date.now();
      remainingTime = autoplaySpeed;

      if (progressBar) {
        progressBar.style.transition = 'none';
        progressBar.style.width = '0%';
        void progressBar.offsetWidth; // force reflow
        progressBar.style.transition = `width ${remainingTime}ms linear`;
        progressBar.style.width = '100%';
      }

      autoplayTimer = setTimeout(() => { nextSlide(); }, remainingTime);
    };

    const pauseAutoplay = () => {
      if (!autoplay || !autoplayTimer) return;
      clearTimeout(autoplayTimer);
      autoplayTimer = null;

      if (progressBar) {
        const elapsed = Date.now() - startTime;
        remainingTime = Math.max(autoplaySpeed - elapsed, 0);
        const currentWidth = Math.min((elapsed / autoplaySpeed) * 100, 100);
        progressBar.style.transition = 'none';
        progressBar.style.width = `${currentWidth}%`;
      }
    };

    const resumeAutoplay = () => {
      if (!autoplay || autoplayTimer) return;
      startTime = Date.now();

      if (progressBar) {
        void progressBar.offsetWidth;
        progressBar.style.transition = `width ${remainingTime}ms linear`;
        progressBar.style.width = '100%';
      }

      autoplayTimer = setTimeout(() => { nextSlide(); }, remainingTime);
    };

    const resetAutoplay = () => {
      if (!autoplay) return;
      clearTimeout(autoplayTimer);
      autoplayTimer = null;
      // Always restart from the full duration regardless of isPaused.
      // On mobile, isPaused is never set via mouse events (see isTouchDevice guard),
      // so this path is always clean. On desktop, the user has moved their
      // mouse away to click a button, so restarting is correct too.
      startAutoplay();
    };

    /* ── Mouse hover pause (desktop only) ───────────────── */
    // CRITICAL: On touch devices (Android/iOS), mouseenter fires on tap.
    // If we set isPaused=true here, resetAutoplay inside goToSlide will
    // see isPaused=true and refuse to restart the timer — permanently
    // breaking autoplay after the first manual navigation.
    if (!isTouchDevice) {
      slider.addEventListener('mouseenter', () => {
        isPaused = true;
        pauseAutoplay();
      });

      slider.addEventListener('mouseleave', () => {
        isPaused = false;
        resumeAutoplay();
      });
    }

    /* ── Init ────────────────────────────────────────────── */
    if (autoplay) startAutoplay();
  });
});
